export const theme = {
  mobile: "768px"
};
